
import React,{ useState, useEffect, useRef } from 'react';

import * as echarts from 'echarts/core';  
import { LineChart } from 'echarts/charts';

echarts.use([LineChart]);

const ChartLineDom = () =>{
  const chartRef = useRef(null);
  // rgb(219,219,218)
  useEffect(() => {
    const chart = echarts.init(chartRef.current);
    let option = {
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['0', '10', '20', '30', '40', '50', '60', '70', '80', '90', '100'],
        splitLine: {
          show: true, 
          lineStyle: {
            color: 'rgb(219,219,218)', 
            type: 'dashed'
          }
        }
      },
      yAxis: {
        type: 'value',
        axisLabel:{
          show: false
        },
        splitLine: {
          show: false
        }
      },
      color: ['rgb(189,0,0)', '#272724'],
      series: [
        {
          symbol: 'none',
          data: [20, 50, 80, 85, 83, 80, 77, 73, 68, 62, 55],
          type: 'line',
          smooth: true
        },
        {
          symbol: 'none',
          data: [20, 50, 80, 85, 80, 70, 60, 50, 40, 30, 20],
          type: 'line',
          smooth: true
        },
      ]
    };
    chart.setOption(option);

    
    const handleResize = () => {
      chart.resize({
        width: 'auto',  // 宽度随着父容器变化而变化
        height: 'auto'  // 高度随着父容器变化而变化
      });
    };
 
    // 监听窗口大小变化
    window.addEventListener('resize', handleResize);

 
    // 清理函数，组件卸载时移除监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);
  return (
    <div style={{width:'100%',height:'45vh', marginTop: 0}} ref={chartRef}></div>
  )
}

export default ChartLineDom